module.exports = __webpack_public_path__ + "static/media/driver1.9ce1c254.png";